/*
* Resideo/LifeWhere
* Copyright (C) 2018-2023 Resideo/LifeWhere
* mailto:nathan.williams@resideo.com
*/

import http from "../http-common";

const controller = "/installs";
const installService = {
    getinstallbymacid: async (macId) => {
        const response = await http.post(`${controller}/getinstallbymacid?macId=${macId}&api-version=2.0`);
        return response.data;
    },

    getmonthlypartnerinstalls(month, year, partnerId) {
        // Pro-only partners have a non-integer RIS ID — pass it as proCompanyId so the
        // backend can resolve the integer partnerId from the Partners table.
        if (partnerId && isNaN(parseInt(partnerId))) {
            return http.post(`${controller}/getmonthlypartnerinstalls?month=${month}&year=${year}&proCompanyId=${encodeURIComponent(partnerId)}&api-version=2.0`);
        }
        return http.post(`${controller}/getmonthlypartnerinstalls?month=${month}&year=${year}&partnerId=${partnerId}&api-version=2.0`);
    },
    
    gethistoricalinstallchecks(installId) {
        return http.get(`${controller}/historicalinstallchecks?installId=${installId}&api-version=2.0`);
    },

    getinstallsbycustomerorgid: async (customerOrgId) => {
        return await http.get(`${controller}/getinstalls/${customerOrgId}?api-version=2.0`);
    },

    getreplacementinstallsbymacaddress: async (macAddress) => {
        return await http.get(`${controller}/getreplacementinstalls/${macAddress}?api-version=2.0`);
    },
    
    updateinstall: async (install) => {
        return await http.put(`${controller}?api-version=2.0`, install);
    },
};
export default installService;
